<template>
  <span class="rm_badge label label-important js-tooltip" data-title="Richiesta motivata"> RM </span>
</template>
<script>
export default {
  name: 'rmLabel',
};
</script>
